// extracted by mini-css-extract-plugin
module.exports = {"icon":"RLmt8RpFu0mQyVeMbXYkH","boxSelect":"_16pTABOn--dmDQ3g-sh5pU","layoutIcon":"z72x7qVwWvzRbAXtham9y","active":"_33_4hjj6nIgLD5R_wM21U0"};